import Modal from "@shared/v2/Modal";
import SmsConversation from "../../SmsConversation/components/SmsConversation";

const SmsModal = ({ modalOpen, closeModal, person, defaultHomeAppTabContent, listingId }) => (
  <Modal
    show={modalOpen}
    onHide={closeModal}
    contentSize="medium"
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[720px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Send Text" closeButton />
    <Modal.Body className="tw-relative tw-overflow-auto">
      <SmsConversation
        person={person}
        closeModal={closeModal}
        defaultHomeAppTabContent={defaultHomeAppTabContent}
        listingId={listingId}
      />
    </Modal.Body>
  </Modal>
);

export default SmsModal;
